<script setup>
import NavBar from '@/components/NavBar'
import Header from '@/components/HeaderComponent'
import Overview from '@/components/Overview'
import Registration from '@/components/Registration'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
import Submission from '@/components/Submission'
import Scheduler from '@/components/Scheduler'
import Organizers from '@/components/Organizers'
import Speakers from '@/components/Speakers'
import Sponsors from '@/components/Sponsors'
import AgendaDetails from '@/components/AgendaDetails.vue'
import {inject} from 'vue'
import Award from '@/components/Award'
import RegistrationPht from '@/components/RegistrationPht.vue'
import CallForAbstracts from '@/components/CallForAbstracts.vue'
import PanelDiscussion from '@/components/PanelDiscussion.vue'
import axios from 'axios'
import {ref, onMounted} from 'vue'

const blocks = ref([])

onMounted(async () => {
    blocks.value = await getBlocksData(blocksURL)
})

const contentData = inject('contentData')

const mainTitle = document.getElementById('mainTitle')
const favicon = document.getElementById('favicon')
if (contentData.what === 'rn') {
    mainTitle.innerHTML = 'Swiss Reproducibility Conference 2024'
    favicon.href = '<%= BASE_URL %>iconRN.ico"'
}

const blocksURL = 'api/blocks'

const backEndURL = process.env.VUE_APP_BACKEND_URL

const getBlocksData = async () => {
    try {
        const res = await axios.get(`${backEndURL}/${blocksURL}`)
        return res.data.map(block => {
            return {
                ...block,
                block_elements: createBlockElementsObject(block.block_elements),
            }
        })
    } catch (err) {
        console.error(err)
    }
}

const createBlockElementsObject = blockElements => {
    const obj = {}
    for (const item of blockElements) {
        obj[item.name] = {content: item.text, display: item.display}
    }
    return obj
}

const filterBlockByTitle = title => {
    return blocks.value.filter(block => block.title === title)[0].block_elements
}

const checkIfBlockDisplay = title => {
    const block = blocks.value.find(block => block.title === title)
    return block.display
}
</script>

<template>
    <div class="relative" v-if="blocks.length > 0">
        <NavBar />
        <Header :data="filterBlockByTitle('Header')" />

        <Overview
            v-if="contentData.overview.display && checkIfBlockDisplay('Overview')"
            :data="filterBlockByTitle('Overview')" />
        <Scheduler
            v-if="contentData.sessions.display && checkIfBlockDisplay('Scheduler')"
            :data="filterBlockByTitle('Scheduler')" />
        <AgendaDetails v-if="contentData.sessions.display && contentData.what === 'rn'" />
        <Award v-if="contentData.award.display" />
        <Speakers v-if="contentData.speakers.display" />
        <AgendaDetails v-if="contentData.sessions.display && contentData.what === 'pht'" />
        <PanelDiscussion
            :data="filterBlockByTitle('Panel_Discussion')"
            v-if="checkIfBlockDisplay('Panel_Discussion')" />
        <Registration v-if="contentData.registration.display && contentData.what === 'rn'" />
        <RegistrationPht
            v-if="contentData.what === 'pht' && checkIfBlockDisplay('Registration')"
            :data="filterBlockByTitle('Registration')" />
        <Submission v-if="contentData.submission.display" />
        <Sponsors :data="filterBlockByTitle('Sponsors')" v-if="checkIfBlockDisplay('Sponsors')" />
        <CallForAbstracts
            :data="filterBlockByTitle('Call_for_abstracts')"
            v-if="checkIfBlockDisplay('Call_for_abstracts')" />
        <Organizers />
        <Contact />
        <Footer />
    </div>
</template>

<style scoped></style>
